<template>
  <div class="page_box">
    <div class="header-section">
      <el-page-header @back="goBack()" content="用户画像详情">
        <template #content>
          <div class="header-content">
            <h2>用户画像详情</h2>
            <el-tag type="success" size="small">VIP用户</el-tag>
          </div>
        </template>
        <template #extra>
          <div class="header-actions">
            <el-button type="primary" icon="el-icon-star-off">收藏用户</el-button>
            <el-button type="success" icon="el-icon-chat-dot-round">联系用户</el-button>
            <el-button icon="el-icon-share">分享报告</el-button>
          </div>
        </template>
      </el-page-header>
    </div>

    <div class="main-content">
      <!-- 用户基本信息区域 -->
      <div class="user-basic-section">
        <div class="user-card">
          <div class="user-header">
            <el-avatar :size="80" :src="userInfo.avatar || defaultAvatar" class="user-avatar"></el-avatar>
            <div class="user-basic">
              <h3>{{ userInfo.userName }}</h3>
              <p class="user-id">ID: {{ userInfo.userId }}</p>
              <div class="user-tags">
                <el-tag :type="userInfo.gender === 1 ? 'primary' : 'danger'" size="mini">
                  {{ userInfo.gender === 1 ? '男' : '女' }}
                </el-tag>
                <el-tag type="info" size="mini">{{ userInfo.age }}岁</el-tag>
              </div>
            </div>
          </div>

          <div class="user-contact">
            <div class="contact-item">
              <i class="el-icon-phone"></i>
              <span>{{ userInfo.mobile }}</span>
            </div>
            <div class="contact-item">
              <i class="el-icon-location"></i>
              <span>{{ userInfo.city }}</span>
            </div>
          </div>
        </div>

        <!-- 用户统计数据 -->
        <div class="user-stats">
          <div class="stat-item">
            <div class="stat-value">¥{{ userInfo.totalConsumption }}</div>
            <div class="stat-label">累计消费</div>
          </div>
          <div class="stat-item">
            <div class="stat-value">{{ userInfo.consumptionFrequency }}</div>
            <div class="stat-label">平均服务周期(天)</div>
          </div>
          <div class="stat-item">
            <div class="stat-value">{{userInfo.consumeTimes}}</div>
            <div class="stat-label">累计消费次数</div>
          </div>
        </div>

        <!-- 用户标签 -->
        <div class="user-tags-section">
          <div class="section-header">
            <i class="el-icon-collection-tag"></i>
            <h3>用户标签</h3>
          </div>
          <div class="tag-cloud">
            <el-tag v-for="(tag, index) in userInfo.labels" :key="index"
                    class="tag-item">{{ tag }}</el-tag>
            <div v-if="!userInfo.labels || userInfo.labels.length === 0" class="no-tags">
              暂无标签数据
            </div>
          </div>
        </div>
      </div>

      <!-- 详细信息区域 -->
      <div class="detail-section">
        <!-- 车辆信息 -->
        <div class="detail-card">
          <div class="card-header">
            <i class="el-icon-car"></i>
            <h3>车辆信息</h3>
            <el-tag type="warning" size="mini">核心资产</el-tag>
          </div>
          <div class="card-content">
            <!-- 单车型展示 -->
            <div v-if="!userInfo.vehicleModels || userInfo.vehicleModels.length === 0">
              <el-row :gutter="20">
                <el-col :span="8">
                  <div class="info-item">
                    <div class="info-label">车型</div>
                    <div class="info-value">{{ userInfo.model || '暂无信息' }}</div>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="info-item">
                    <div class="info-label">购车时间</div>
                    <div class="info-value">{{ userInfo.purchaseTime || '暂无信息' }}</div>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="info-item">
                    <div class="info-label">行驶里程</div>
                    <div class="info-value">{{ (userInfo.mileage || '未知') }}公里</div>
                  </div>
                </el-col>
              </el-row>
            </div>

            <!-- 单车型展示（carModels数组只有一个元素） -->
            <div v-else-if="userInfo.vehicleModels && userInfo.vehicleModels.length === 1">
              <el-row :gutter="20">
                <el-col :span="8">
                  <div class="info-item">
                    <div class="info-label">车型</div>
                    <div class="info-value">{{ userInfo.vehicleModels[0].model || '暂无信息'}}</div>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="info-item">
                    <div class="info-label">购车时间</div>
                    <div class="info-value">{{ userInfo.vehicleModels[0].purchaseTime || '暂无信息'}}</div>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="info-item">
                    <div class="info-label">行驶里程</div>
                    <div class="info-value">{{ userInfo.vehicleModels[0].mileage || '未知'}}公里</div>
                  </div>
                </el-col>
              </el-row>
            </div>

            <!-- 多车型展示 -->
            <div v-else>
              <el-tabs type="border-card">
                <el-tab-pane
                  v-for="(car, index) in userInfo.vehicleModels"
                  :key="index"
                  :label="car.plateCode">
                  <el-row :gutter="20">
                    <el-col :span="8">
                      <div class="info-item">
                        <div class="info-label">车型</div>
                        <div class="info-value">{{ car.model || '暂无信息'}}</div>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="info-item">
                        <div class="info-label">购车时间</div>
                        <div class="info-value">{{ car.purchaseTime || '暂无信息'}}</div>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="info-item">
                        <div class="info-label">行驶里程</div>
                        <div class="info-value">{{ car.mileage || '未知'}}公里</div>
                      </div>
                    </el-col>
                  </el-row>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>

        <!-- 消费行为 -->
        <div class="detail-card">
          <div class="card-header">
            <i class="el-icon-shopping-cart-2"></i>
            <h3>消费行为</h3>
<!--            <el-tag type="success" size="mini">高价值客户</el-tag>-->
          </div>
          <div class="card-content">
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="info-item">
                  <div class="info-label">累计消费金额</div>
                  <div class="info-value price">¥{{ userInfo.totalConsumption }}</div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="info-item">
                  <div class="info-label">最近一次消费</div>
                  <div class="info-value">{{ userInfo.lastConsumption || '暂无信息' }}</div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="info-item">
                  <div class="info-label">累计消费次数</div>
                  <div class="info-value">{{ userInfo.consumeTimes }} 次</div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>

        <!-- 兴趣偏好 -->
        <div class="detail-card">
          <div class="card-header">
            <i class="el-icon-star-off"></i>
            <h3>兴趣偏好</h3>
          </div>
          <div class="card-content">
            <div class="tags-cloud">
              <el-tag v-for="(tag, index) in userInfo.interests" :key="index"
                      class="interest-tag">{{ tag }}</el-tag>
            </div>
          </div>
        </div>

        <!-- 预计换车计划 -->
        <div class="detail-card">
          <div class="card-header">
            <i class="el-icon-refresh"></i>
            <h3>预计换车计划</h3>
            <el-tag type="danger" size="mini">商机</el-tag>
          </div>
          <div class="card-content">
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="info-item">
                  <div class="info-label">预计换车时间</div>
                  <div class="info-value">{{ userInfo.carChangeForecast.expectedReplacementTime || '' }}</div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="info-item">
                  <div class="info-label">预算范围</div>
                  <div class="info-value">{{ userInfo.carChangeForecast.budgetRange || '' }}</div>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top: 15px;">
              <el-col :span="24">
                <div class="info-item">
                  <div class="info-label">换车关注点</div>
                  <div class="replacement-focus-tags">
                    <el-tag v-for="(focus, index) in userInfo.carChangeForecast.replacementFocus" :key="index"
                            type="success">{{ focus }}</el-tag>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>

        <!-- 车辆服务商机 -->
        <div class="detail-card">
          <div class="card-header">
            <i class="el-icon-truck"></i>
            <h3>车辆服务商机</h3>
            <el-tag type="warning" size="mini">商机</el-tag>
          </div>
          <div class="card-content">
            <!-- 第一部分：展示商机相关信息 -->
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="info-item">
                  <div class="info-label">商机车服务</div>
                  <div class="info-value">{{ userInfo.serveBusinessOpportunities.recommendedServices || '暂无信息' }}</div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="info-item">
                  <div class="info-label">预计下次保养时间</div>
                  <div class="info-value">{{ userInfo.serveBusinessOpportunities.nextMaintenanceTime || '暂无信息' }}</div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="info-item">
                  <div class="info-label">预计下次易损件更换时间</div>
                  <div class="info-value">{{ userInfo.serveBusinessOpportunities.nextWearReplacementTime || '暂无信息' }}</div>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top: 15px;">
              <el-col :span="8">
                <div class="info-item">
                  <div class="info-label">预计下次洗车时间</div>
                  <div class="info-value">{{ userInfo.serveBusinessOpportunities.nextCarWashTime || '暂无信息' }}</div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="info-item">
                  <div class="info-label">预计下次补能时间</div>
                  <div class="info-value">{{ userInfo.serveBusinessOpportunities.nextEnergyTime || '暂无信息' }}</div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="info-item">
                  <div class="info-label">预计下次保险时间</div>
                  <div class="info-value">{{ userInfo.serveBusinessOpportunities.nextInsuranceTime || '暂无信息' }}</div>
                </div>
              </el-col>
            </el-row>

            <!-- 第二部分：采用列表形式展示商机产品信息 -->
            <el-row :gutter="20" style="margin-top: 20px;">
              <el-col :span="24">
                <el-table :data="userInfo.serveBusinessOpportunities.businessProducts" style="width: 100%" border>
                  <el-table-column prop="productName" label="商机产品" min-width="150"></el-table-column>
                  <el-table-column prop="salePrice" label="销售价格" min-width="100">
                    <template slot-scope="scope">
                      <span class="price-text">¥{{ scope.row.salePrice }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="costPrice" label="成本价" min-width="100">
                    <template slot-scope="scope">
                      <span>¥{{ scope.row.costPrice }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="expectedProfit" label="预计收益" min-width="100">
                    <template slot-scope="scope">
                      <span class="price-text">¥{{ scope.row.expectedProfit }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="商品图" min-width="120">
                    <template slot-scope="scope">
                      <el-image
                        :src="scope.row.productImage"
                        fit="cover"
                        :preview-src-list="[scope.row.productImage]"
                        style="width: 80px; height: 60px; border-radius: 4px;"
                        lazy>
                        <div slot="error" class="image-error">
                          <i class="el-icon-picture-outline"></i>
                        </div>
                      </el-image>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>
        </div>

        <!-- 生活商机 -->
        <div class="detail-card">
          <div class="card-header">
            <i class="el-icon-coffee-cup"></i>
            <h3>生活商机</h3>
            <el-tag type="success" size="mini">商机</el-tag>
          </div>
          <div class="card-content">
            <!-- 第一行：办公地点和常去商圈 -->
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="info-item">
                  <div class="info-label">办公地点</div>
                  <div class="info-value">{{ userInfo.lifeBusinessOpportunities.officeLocation || '暂无信息' }}</div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="info-item">
                  <div class="info-label">常去商圈</div>
                  <div class="info-value">{{ userInfo.lifeBusinessOpportunities.frequentBusinessDistrict || '暂无信息' }}</div>
                </div>
              </el-col>
            </el-row>

            <!-- 日用品 -->
            <div class="life-section">
              <h4>日用品</h4>
              <el-table :data="userInfo.lifeBusinessOpportunities.dailySupplies" style="width: 100%" border>
                <el-table-column prop="nextTime" label="预计下次日用品时间" min-width="120"></el-table-column>
                <el-table-column prop="itemName" label="日用品" min-width="120"></el-table-column>
                <el-table-column prop="salePrice" label="日用品销售价" min-width="100">
                  <template slot-scope="scope">
                    <span class="price-text" v-if="scope.row.salePrice">¥{{ scope.row.salePrice }}</span>
                    <span class="price-text"  v-else></span>
                  </template>
                </el-table-column>
                <el-table-column prop="costPrice" label="日用品成本价" min-width="100">
                  <template slot-scope="scope">
                    <span class="price-text" v-if="scope.row.costPrice">¥{{ scope.row.costPrice }}</span>
                    <span class="price-text"  v-else></span>
                  </template>
                </el-table-column>
                <el-table-column prop="expectedProfit" label="预计收益" min-width="100">
                  <template slot-scope="scope">
                    <span class="price-text" v-if="scope.row.expectedProfit">¥{{ scope.row.expectedProfit }}</span>
                    <span class="price-text"  v-else></span>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <!-- 居家保洁 -->
            <div class="life-section" style="margin-top: 20px;">
              <h4>居家保洁</h4>
              <el-table :data="userInfo.lifeBusinessOpportunities.homeCleaning" style="width: 100%" border>
                <el-table-column prop="nextTime" label="预计下次家政服务时间" min-width="120"></el-table-column>
                <el-table-column prop="salePrice" label="家政服务销售价" min-width="100">
                  <template slot-scope="scope">
                    <span class="price-text" v-if="scope.row.salePrice">¥{{ scope.row.salePrice }}</span>
                    <span class="price-text" v-else></span>
                  </template>
                </el-table-column>
                <el-table-column prop="costPrice" label="家政服务成本价" min-width="100">
                  <template slot-scope="scope">
                    <span class="price-text" v-if="scope.row.costPrice">¥{{ scope.row.costPrice }}</span>
                    <span class="price-text" v-else></span>
                  </template>
                </el-table-column>
                <el-table-column prop="expectedProfit" label="预计收益" min-width="100">
                  <template slot-scope="scope">
                    <span class="price-text" v-if="scope.row.expectedProfit">¥{{ scope.row.expectedProfit }}</span>
                    <span class="price-text" v-else></span>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <!-- KTV娱乐 -->
            <div class="life-section" style="margin-top: 20px;">
              <h4>KTV娱乐</h4>
              <el-table :data="userInfo.lifeBusinessOpportunities.ktvEntertainment" style="width: 100%" border>
                <el-table-column prop="nextTime" label="预计下次生活娱乐时间" min-width="120"></el-table-column>
                <el-table-column prop="salePrice" label="生活娱乐销售价" min-width="100">
                  <template slot-scope="scope">
                    <span class="price-text" v-if="scope.row.salePrice">¥{{ scope.row.salePrice }}</span>
                    <span class="price-text"></span>
                  </template>
                </el-table-column>
                <el-table-column prop="costPrice" label="生活娱乐成本价" min-width="100">
                  <template slot-scope="scope">
                    <span v-if="scope.row.costPrice" class="price-text">¥{{ scope.row.costPrice }}</span>
                    <span v-else class="price-text"></span>
                  </template>
                </el-table-column>
                <el-table-column prop="expectedProfit" label="预计收益" min-width="100">
                  <template slot-scope="scope">
                    <span class="price-text" v-if="scope.row.expectedProfit">¥{{ scope.row.expectedProfit }}</span>
                    <span class="price-text" v-else></span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>

        <!-- 服务记录 -->
        <div class="detail-card">
          <div class="card-header">
            <i class="el-icon-document"></i>
            <h3>服务记录</h3>
          </div>
          <div class="card-content">
            <el-table :data="serviceRecords" style="width: 100%"
                      :header-cell-style="{background: '#f8f9fa', color: '#606266'}">
              <el-table-column prop="serviceNames" label="服务项目"></el-table-column>
              <el-table-column prop="orderTime" label="服务时间"></el-table-column>
              <el-table-column label="服务技师">
                <template slot-scope="scope">
                  <div class="advisors-container">
                    <el-tag v-for="(advisor, index) in scope.row.technicianNames.split(',')"
                            :key="index"
                            size="mini"
                            type="success"
                            class="advisor-tag">
                      {{ advisor || 'SYSTEM'}}
                    </el-tag>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="amount" label="消费金额">
                <template slot-scope="scope">
                  <span class="price-text">¥{{ scope.row.orderAmount }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="satisfaction" label="满意度">
                <template slot-scope="scope">
                  <el-rate v-model="satisfaction" disabled></el-rate>
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页组件 -->
            <div class="pagination-container">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 20, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "PortraitDetail",
  data() {
    return {
      defaultAvatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
      userInfo: {},
      serviceRecords: [],
      // 分页相关数据
      currentPage: 1,
      pageSize: 5,
      total: 0,
      mobile: '',
      rowIndex: 1,
      page: 1,
      satisfaction: 5,
    }
  },
  created() {
    this.getUserInfo();
    this.getServiceRecords();
  },
  methods: {
        // 处理商品图片显示
        handleProductImage(imageUrl) {
          return imageUrl || 'https://example.com/images/default-product.jpg';
        },

        // 获取用户信息
        getUserInfo() {
          // 获取查询参数
          this.mobile = this.$route.query.mobile;
          this.page = this.$route.query.page;
          this.rowIndex = this.$route.query.rowIndex;
          // 构造请求参数
          const params = {
            mobile: this.mobile,  // 优先使用手机号，如果没有则使用标识符
            pageNum: this.page,
            rowIndex: this.rowIndex
          };

          // 调用接口获取用户详情数据
          this.$store.dispatch('portrait/getUserPortraitDetail', params).then(res => {
            if (res.code === '0') {
              // 成功获取数据，设置用户信息
              this.userInfo = res.data;
            } else {
              // 获取数据失败，使用默认数据或显示错误信息
              console.error('获取用户详情失败:', res);
              this.$message.error('获取用户详情失败: ' + (res.message || '未知错误'));
            }
          }).catch(error => {
            console.error('获取用户详情异常:', error);
            this.$message.error('获取用户详情异常: ' + error.message);
          });
        },

    // 获取服务记录
    getServiceRecords() {
      // 调用接口获取服务记录数据
      this.$store.dispatch('customer/getUserExpensesRecord', {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        mobile: this.mobile
      }).then(res => {
        if (res.code === '0') {
          // 成功获取数据，设置服务记录和分页信息
          this.serviceRecords = res.data.list || [];
          this.total = res.data.count || 0;
        } else {
          // 获取数据失败，使用默认数据或显示错误信息
          console.error('获取服务记录失败:', res);
          this.$message.error('获取服务记录失败: ' + (res.message || '未知错误'));
          // 使用空数据作为后备
          this.serviceRecords = [];
          this.total = 0;
        }
      }).catch(error => {
        console.error('获取服务记录异常:', error);
        this.$message.error('获取服务记录异常: ' + error.message);
        // 使用空数据作为后备
        this.serviceRecords = [];
        this.total = 0;
      });
    },

    // 返回上一页
    goBack() {
      this.$router.replace({ path: '/portrait/list' })
    },

    // 分页大小改变
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getServiceRecords();
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getServiceRecords();
    }
  }
}
</script>

<style lang="scss" scoped>
.page_box {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 84px);
}

.header-section {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 15px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  color: white;

  ::v-deep .el-page-header {
    background: transparent;
  }

  ::v-deep .el-page-header__content {
    color: white;

    .header-content {
      display: flex;
      align-items: center;
      gap: 15px;

      h2 {
        margin: 0;
        font-size: 24px;
        font-weight: 600;
      }
    }
  }

  ::v-deep .el-page-header__left {
    color: white;
  }

  ::v-deep .el-icon-arrow-left {
    color: white;
  }

  ::v-deep .el-page-header__title {
    color: rgba(255, 255, 255, 0.9);
  }

  .header-actions {
    display: flex;
    gap: 10px;
  }
}

.main-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.user-basic-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.user-card {
  background: linear-gradient(135deg, #ffffff 0%, #f5f7fa 100%);
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.05);
  text-align: center;

  .user-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 25px;
    padding-bottom: 25px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);

    .user-avatar {
      width: 100px;
      height: 100px;
      border-radius: 50%;
      border: 3px solid #409eff;
      box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
      margin-bottom: 15px;
    }

    .user-basic {
      h3 {
        font-size: 24px;
        font-weight: 700;
        color: #2c3e50;
        margin-bottom: 5px;
      }

      .user-id {
        font-size: 14px;
        color: #7f8c8d;
        margin-bottom: 10px;
      }

      .user-tags {
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
        justify-content: center;

        .el-tag {
          margin: 0;
          border-radius: 15px;
          padding: 5px 12px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }

  .user-contact {
    .contact-item {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 12px;
      font-size: 14px;
      color: #606266;

      i {
        color: #409eff;
        font-size: 16px;
      }
    }
  }
}

.user-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 15px;
  background: linear-gradient(135deg, #ffffff 0%, #f5f7fa 100%);
  border-radius: 15px;
  padding: 20px;
}

.user-tags-section,
.detail-card {
  background: linear-gradient(135deg, #ffffff 0%, #f5f7fa 100%);
  border-radius: 15px;
  padding: 25px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.05);

  .card-header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);

    i {
      font-size: 20px;
      color: #409eff;
    }

    h3 {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
      color: #2c3e50;
    }

    .el-tag {
      margin: 0;
      border-radius: 10px;
      padding: 3px 8px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
  }

  .card-content {
    .info-item {
      margin-bottom: 15px;

      .info-label {
        font-size: 14px;
        color: #7f8c8d;
        margin-bottom: 5px;
      }

      .info-value {
        font-size: 16px;
        color: #2c3e50;
        font-weight: 500;

        &.price {
          color: #e74c3c;
          font-weight: 600;
        }
      }

      .replacement-focus-tags,
      .service-description {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
      }

      .service-description {
        font-size: 14px;
        color: #606266;
        line-height: 1.5;
      }
    }
  }
}

.tags-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;

  .interest-tag,
  .el-tag {
    margin: 0;
    border-radius: 15px;
    padding: 6px 15px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .interest-tag {
    background: #e3f2fd;
    border: 1px solid #bbdefb;
    color: #1976d2;
    font-weight: 500;
  }
}

.replacement-focus-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;

  .el-tag {
    margin: 0;
    border-radius: 15px;
    padding: 6px 15px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-radius: 12px;
  background: rgba(64, 158, 255, 0.08);
  border: 1px solid rgba(64, 158, 255, 0.2);

  .stat-value {
    font-size: 24px;
    font-weight: 700;
    color: #409eff;
    margin-bottom: 5px;
  }

  .stat-label {
    font-size: 14px;
    color: #7f8c8d;
    font-weight: 500;
  }
}

.user-tags-section {
  background: linear-gradient(135deg, #ffffff 0%, #f5f7fa 100%);
  border-radius: 15px;
  padding: 25px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.05);

  .section-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;

    i {
      font-size: 18px;
      color: #409eff;
    }

    h3 {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
      color: #2c3e50;
    }

    .el-tag {
      margin: 0;
      border-radius: 10px;
      padding: 3px 8px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
  }

  .tag-cloud {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;

    .tag-item {
      margin: 0;
      border-radius: 20px;
      padding: 8px 16px;
      background: #e3f2fd;
      border: 1px solid #bbdefb;
      color: #1976d2;
      font-weight: 500;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    .no-tags {
      color: #7f8c8d;
      font-style: italic;
    }
  }
}

.detail-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.detail-card {
  background: linear-gradient(135deg, #ffffff 0%, #f5f7fa 100%);
  border-radius: 15px;
  padding: 25px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.05);

  .card-header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);

    i {
      font-size: 18px;
      color: #409eff;
    }

    h3 {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
      color: #2c3e50;
    }

    .el-tag {
      margin: 0;
      border-radius: 10px;
      padding: 3px 8px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
  }

  .card-content {
    .info-item {
      margin-bottom: 15px;
      padding: 15px;
      border-radius: 8px;
      background: rgba(64, 158, 255, 0.03);
      border-left: 3px solid #409eff;

      .info-label {
        font-size: 14px;
        color: #7f8c8d;
        margin-bottom: 5px;
      }

      .info-value {
        font-size: 16px;
        color: #2c3e50;
        font-weight: 500;

        &.price {
          color: #67c23a;
          font-weight: 600;
          font-size: 18px;
        }
      }
    }
  }
}





.price-text {
  color: #67c23a;
  font-weight: 600;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  padding: 20px 0;
  background: #fff;
  border-radius: 8px;
}

.advisors-container {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.advisor-tag {
  margin: 0;
}

@media (min-width: 769px) {
  .main-content {
    flex-direction: row;
  }

  .user-basic-section {
    width: 35%;
  }

  .detail-section {
    width: 65%;
  }

  .main-content {
    display: flex;
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .page_box {
    padding: 10px;
  }

  .header-section {
    padding: 15px;
    border-radius: 12px;

    ::v-deep .el-page-header__content {
      .header-content {
        h2 {
          font-size: 20px;
        }
      }
    }
  }

  .user-card {
    padding: 20px;
    border-radius: 12px;

    .user-header {
      flex-direction: column;
      text-align: center;
      gap: 15px;
      padding-bottom: 15px;
    }

    .user-basic {
      h3 {
        font-size: 20px;
      }
    }
  }

  .user-stats {
    flex-direction: column;
    gap: 15px;
    padding: 20px;
    border-radius: 12px;

    .stat-item {
      width: 100%;
      padding: 12px;

      .stat-value {
        font-size: 20px;
      }
    }
  }

  .user-tags-section,
  .detail-card {
    padding: 20px;
    border-radius: 12px;

    .card-header {
      h3 {
        font-size: 16px;
      }
    }

    .card-content {
      .info-item {
        .info-value {
          font-size: 14px;

          &.price {
            font-size: 16px;
          }
        }
      }
    }
  }

  .tags-cloud {
    gap: 10px;

    .interest-tag,
    .el-tag {
      padding: 6px 12px;
      font-size: 12px;
    }

    .interest-tag {
      background: #e3f2fd;
      border: 1px solid #bbdefb;
      color: #1976d2;
    }
  }

  .replacement-focus-tags {
    gap: 10px;

    .el-tag {
      padding: 6px 12px;
      font-size: 12px;
    }
  }
}
</style>
